import { render, staticRenderFns } from "./OtherDeposit.vue?vue&type=template&id=5782bbde&"
import script from "./OtherDeposit.vue?vue&type=script&lang=js&"
export * from "./OtherDeposit.vue?vue&type=script&lang=js&"
import style0 from "./OtherDeposit.vue?vue&type=style&index=0&id=5782bbde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports